import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import PaginationModified from "../../../data/PaginationModified";
import { formatDateTimezon } from "../../common-data/Converts";
import { fetchHygineAddonRequestsData } from "../../../redux/hygiene-reducers/hygieneSlice";

const MergedTasks = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const {
    hygineAddonRequestsLoading,
    hygineAddonRequestsError,
    hygineAddonRequests,
  } = useSelector((state) => state.hygiene);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    request_id: rowData?.uid || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  function getPagination() {
    try {
      const pagination =
        allDatas.pagination?.length > 0 ? allDatas.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  function getHygieneRequests() {
    if (filters.request_id) {
      dispatch(
        fetchHygineAddonRequestsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );
    }
  }

  useEffect(() => {
    getHygieneRequests();
  }, [filters]);

  useEffect(() => {
    if (
      !hygineAddonRequestsLoading &&
      !hygineAddonRequestsError &&
      hygineAddonRequests?.status &&
      hygineAddonRequests?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: hygineAddonRequests.data,
        pagination:
          hygineAddonRequests?.pagination?.length > 0
            ? hygineAddonRequests.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [
    hygineAddonRequestsLoading,
    hygineAddonRequestsError,
    hygineAddonRequests,
  ]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  const tbColumns1 = [
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "requested_by",
      text: "requested by",
      formatter: (_, row) => {
        return (
          <span className="tb-data underline">
            <small className="gray">
              {row?.requested_account_type?.replace(/_/g, " ") || ""}
            </small>
            <br />
            {row?.requested_by_name || "NA"}
            <br />
            <small className="lowercase">
              {row?.requested_by_mobile || ""}
              <br />
              {row?.requested_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
    {
      dataField: "description",
      text: "description",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.description || "NA"}</span>;
      },
    },
  ];

  return (
    <>
      {hygineAddonRequestsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile no-border-table mt30">
            <PaymentLinkTable
              tableData={allDatas.allData}
              tableColumns={tbColumns1}
              tablePagination={allDatas.pagination}
              isPage={isPage}
              setIsPage={(value) => setIsPage(value)}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
            />
          </div>

          <div className="lead-logs-card-container only-mobile">
            <div className="all-leads-log mt30">
              {allDatas.allData?.length > 0 &&
                allDatas.allData.map((row, index) => {
                  return (
                    <div className="log-card" key={index}>
                      <div className="all-info">
                        <div className="all-followuo-info-container">
                          <div
                            className="lead-multi-value-cols px20px pb20px"
                            style={{ paddingTop: "20px" }}
                          >
                            <div className="label-value flex-col">
                              <span className="label">requested by</span>
                              <span className="value">
                                <small className="gray">
                                  (
                                  {row?.requested_account_type?.replace(
                                    /_/g,
                                    " "
                                  ) || ""}
                                  )
                                </small>
                                <br />
                                {row?.requested_by_name || "NA"}
                                <br />
                                <small className="lowercase">
                                  {row?.requested_by_mobile || ""}
                                  <br />
                                  {row?.requested_by_email || ""}
                                </small>
                              </span>
                            </div>

                            <div className="label-value">
                              <span className="label">Status</span>
                              <span className="value">
                                {row?.status || "NA"}
                              </span>
                            </div>

                            <div className="label-value flex-col">
                              <span className="label">description</span>
                              <span className="value">
                                {row?.description || "NA"}
                              </span>
                            </div>

                            <div className="label-value">
                              <span className="label">date added</span>
                              <span className="value">
                                {row?.date_added
                                  ? formatDateTimezon(row.date_added)
                                  : "-"}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

              <div className="lead-logs-card-pagination">
                <PaginationModified
                  isPage={isPage}
                  onChangePage={setIsPage}
                  pagination={getPagination()}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default MergedTasks;
